var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feat-car-placeholder"},[_c('ul',{staticClass:"card"},_vm._l((3),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"feat-slide loading",class:index === 0
            ? _vm.addRightBorder
            : index === 1
            ? _vm.addBorder
            : index === 2
            ? _vm.addLeftBorder
            : ''})])}),0),_c('div',{staticClass:"mobile-card"}),_c('div',{staticClass:"feat-nav-container",attrs:{"id":"feat-nav-container"}},_vm._l((4),function(dummyImage,key){return _c('button',{key:key,staticClass:"nav-button",attrs:{"type":"button"}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }